import { Alert, AlertTitle } from '@mui/material'
import { useCurrentUserResource } from 'infrastructure/auth/auth.hooks'

const ADMIN_ROLES = ['admin', 'super-admin']

export function DemoUserBanner() {
  const user = useCurrentUserResource()
  if (!user) return null

  const isAdmin = user.roles_list?.some((role) => ADMIN_ROLES.includes(role))
  if (isAdmin) return null

  return (
    <Alert severity="error" sx={{ borderRadius: 0 }}>
      <AlertTitle>Access Restricted</AlertTitle>
      You are logged in as {user.name} (
      {user.roles_list?.join(', ') || 'no roles'}). TKAT requires an admin
      account. Please log out of the Kiddom web app and log back in with your
      admin account.
    </Alert>
  )
}
